module.exports = __webpack_public_path__ + "img/AstroFrenz2.0296e398.jpg";